import type { ExperimentConfig } from '../@types'

// DEV-34789 — EU pricing unification, Group 1 (currently €39 renewal → test unified €44 ladder).
// EU-only A/B (variant B = unified €44 renewal ladder). EU-scoping is enforced by the ABsmartly
// audience (country ∈ EU set); every targeted funnel swaps to the same €44 ladder via the shared
// transform. Products are the shared EU+BR unification product set added for the BR pricing work.
// Debug (per funnel): /result_complete?safe&mock-data&utm_source=FB&country=DE&area=<appArea>&exp=web_eu_pricing_unification_g1~1
const paywall = {
	experiment: () =>
		import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_eu_pricing_unification_g1'),
}

const config: ExperimentConfig[] = [
	{
		female: { paywall },
		'activity-male-walking': { paywall },
		'activity-male-chair-tai-chi': { paywall },
		'activity-female-tai-chi-walking-v2-al': { paywall },
		'female-water-fasting': { paywall },
		'activity-male-tai-chi-yoga-pr': { paywall },
		'activity-female-walking': { paywall },
	},
]

export default config
